// tried using classes (extending SketchViewModel) but super() inside constructor didn't work, maybe because...arcgis js is written in typescript....?

import SketchViewModel from '@arcgis/core/widgets/Sketch/SketchViewModel'
import store from '../store/index.js'
import { spEsri } from '../globals.js'

export default (() => {
  const sketch = new SketchViewModel({})
  sketch.gdiOriginalPointSymbol = sketch.pointSymbol.clone()
  sketch.gdiOriginalPolylineSymbol = sketch.polylineSymbol.clone()
  sketch.gdiOriginalPolygonSymbol = sketch.polygonSymbol.clone()
  sketch.gdiListener = null

  sketch.gdiUpdate = function (mode, options) {
    this.view = spEsri.activeView
    this.update(mode, options)
  }

  sketch.gdiCreate = function (mode, options) {
    this.view = spEsri.activeView
    this.create(mode, options)
  }

  sketch.gdiSetListener = function (listener) {
    if (this.gdiListener) {
      this.gdiListener.remove()
      this.gdiListener = null
    }
    this.gdiListener = listener
  }
  sketch.gdiSetProperties = function ({ layer, pointSymbol, polylineSymbol, polygonSymbol, updateOnGraphicClick = false, isSnappingEnabled = true }) {
    this.layer = layer || null
    this.pointSymbol = pointSymbol || this.gdiOriginalPointSymbol
    this.polylineSymbol = polylineSymbol || this.gdiOriginalPolylineSymbol
    this.polygonSymbol = polygonSymbol || this.gdiOriginalPolygonSymbol
    this.updateOnGraphicClick = updateOnGraphicClick
    this.snappingOptions.enabled = isSnappingEnabled
    if (this.gdiListener) {
      this.gdiListener.remove()
      this.gdiListener = null
    }
  }
  sketch.on('update', (event) => {
    if (event.state === 'start') {
      store.dispatch('setIsIdentificationBlocked', true)
    } else if (event.state === 'complete') {
      store.dispatch('setIsIdentificationBlocked', false)
    }
  })

  return sketch
})()
